import React, { Component } from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

import { MAP_HERO_ID_EN } from "@/utils/getting";
import Store from "@/stores";

class RankingItem extends Component {
	static propTypes = {
		battleTag: PropTypes.string,
		classesId: PropTypes.number,
		costTime: PropTypes.string,
		finishTime: PropTypes.string,
		gender: PropTypes.number,
		heroId: PropTypes.number,
		mysticTier: PropTypes.number,
		rank: PropTypes.number,
		serverType: PropTypes.number
	}
	static defaultProps = {
		battleTag: "",
		classesId: 1,
		costTime: "0分0秒",
		finishTime: "",
		gender: 0,
		heroId: 0,
		mysticTier: 0,
		rank: 0,
		serverType: 0
	}
	render() {
		const { battleTag, classesId, costTime, finishTime, gender, heroId, mysticTier, rank, serverType } = this.props;
		const hero = MAP_HERO_ID_EN[classesId] + (gender === 1 ? "-w" : "-m");
		return (
			<li className="ladder-ranking-item clearfix">
				<span className="rank">{rank}</span>
				<span className="btag ellipsis">
					<i className={hero} />
					<Link to={`/ladder/detail?btag=${battleTag}&hero=${heroId}&server=${serverType}`}>{battleTag.split("-")[0]}</Link>
				</span>
				<span className="level">{mysticTier}</span>
				<span className="spend-time">{costTime}</span>
				<span className="finish-time">{finishTime}</span>
			</li>
		);
	}
}

@observer
class Ranking extends Component {
	static propTypes = { _ladderStore: PropTypes.object }
	static defaultProps = { _ladderStore: {} }
	render() {
		const { ranking, rankingIndex } = Store._ladderStore;
		if (!ranking.length) return <div className="ladder-ranking empty tac">暂无数据</div>;
		const list = ranking.map((v, i) => <RankingItem key={v.battleTag} {...Object.assign({}, v, { rank: 50 * rankingIndex + i + 1 })} />);
		return (
			<div className="ladder-ranking">
				<h3 className="clearfix">
					<span className="rank">排名</span>
					<span className="btag">BATTLETAG</span>
					<span className="level">秘境等级</span>
					<span className="spend-time">花费时间</span>
					<span className="finish-time">完成时间</span>
				</h3>
				<ul>{list}</ul>
			</div>
		);
	}
}
export default Ranking;